import * as THREE from 'three';

/**
 * 视锥辅助（CameraHelper）同步 —— three 的 CameraHelper 约定：
 *   `helper.matrix = camera.matrixWorld`（matrixAutoUpdate=false），
 * 即 helper 的「本地矩阵」直接等于相机世界矩阵。
 *
 * 因此当 helper 挂在已带位姿的 group（路径相机机身）下时，cam 必须保持**单位变换**：
 *   helper 世界矩阵 = group.matrixWorld × identity = 机身位姿
 *   → 视锥顶点=机身中心、视锥朝向=镜头方向（相机 -Z）。
 *
 * 2026-10-14 修复（用户反馈「漫游相机不在线条汇聚点、镜头方向不对」）：
 * 此前把 group 的 position/quaternion 写入 cam，与 group 变换叠加（位置×2、旋转²），
 * 导致视锥顶点远离机身、朝向错乱。见 pathCameraHelper.test.ts 回归。
 */
export function syncHelperCameraInGroup(cam: THREE.PerspectiveCamera): void {
  cam.position.set(0, 0, 0);
  cam.quaternion.identity();
  cam.updateMatrixWorld();
}
